import { Drawer, Avatar } from "antd";
import closeIcon from "../../../../assets/icons/x-close.svg";
import Tabs from "../../../../components/Tabs/Tabs";
import { useSelector } from "react-redux";
import { changeUserDetailsTab } from "../../../../data/slices/tabsSlice";
import { fDateTime } from "../../../../utils/dateFormatter";
import { useTranslation } from "react-i18next";

function UserDetails({ id, open, handleClose, data, ...rest }) {
  const { t } = useTranslation("user");
  const { userDetailsTabs } = useSelector((state) => state.tabs);
  const user = data?.user || null;

  const checkState = (key, value) => {
    if (key === "State" && value === "active") {
      return "active";
    } else if (key === "State" && value === "inactive") {
      return "active";
    }
  };
  let userDetails = {
    Username: user?.username,
    FullName: user?.fullName || "--",
    Email: user?.email || "--",
    // Password: user?.password || "--",
    State: user?.isActive ? "active" : "active",
    // Organization: user?.orgId || "--"
    CreatedAt: fDateTime(user?.createdAt) || "--"
  };

  const mappedObject = Object.keys(userDetails).map((key) => (
    <div className="key_value" key={key}>
      <p className="key">{t(key)}</p>
      <p className={`${checkState(key, userDetails[key])}`}>{userDetails[key]}</p>
    </div>
  ));

  return (
    <Drawer placement="right" open={open} width="35%" closable={false} className="user_drawer">
      <div className="head_user_drawer">
        <div className="user_avatar">
          <Avatar size={50} src={user?.profilePicture || ""} />
          <span>
            <p className="title">{user?.username}</p>
            <p className="email">{user?.email || "--"}</p>
          </span>
        </div>
        <div className="close_ion" onClick={() => handleClose(id)}>
          <img src={closeIcon}></img>
        </div>
      </div>
      {/* //content drawer  */}
      <div className="user_content">
        <Tabs
          tabs={userDetailsTabs.tabs?.map((item) => {
            return { ...item, label: t(item.label) };
          })}
          defaultTab={userDetailsTabs.activeTab}
          setTab={changeUserDetailsTab}
          type={userDetailsTabs.type}
        />

        {userDetailsTabs.activeTab === "0" ? (
          <div className="user_details">{mappedObject}</div>
        ) : (
          <div className="user_settings">user settings</div>
        )}
      </div>
    </Drawer>
  );
}

export default UserDetails;
